const library_es = require('./library.json')
export default library_es